module.exports = __webpack_public_path__ + "img/resources1.96473165.jpg";